import {alias, createModelSchema, custom, deserialize, list, serialize, SKIP} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {GuardMoneyRule} from "@/modules/redactor/models/guard/GuardMoneyRule";

export class GuardMoney extends Cloneable {

    static schema() {
        return custom(
            (v) => {
                return v && !v.empty() ? serialize(GuardMoney, v) : SKIP;
            },
            (v) => {
                return deserialize(GuardMoney, v);
            }
        );
    }

    constructor() {
        super();

        this._rules = [];
    }

    get rules() {
        return this._rules;
    }

    set rules(value) {
        this._rules = value;
    }

    valid() {

        if (this.rules && this.rules.some(v => !v || !v.valid())) {
            return false;
        }

        return true;
    }

    empty() {
        return !this.rules || this.rules.length === 0;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new GuardMoney());
        } else if (target instanceof GuardMoney) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(GuardMoney, {
    _rules: alias("rules", list(GuardMoneyRule.schema())),
});